// API configuration
export const API_CONFIG = {
  baseUrl: 'https://api.extensiverewards.com',
  endpoints: {
    points: {
      balance: '/api/points/balance',
      transactions: '/api/points/transactions'
    },
    offerwalls: {
      list: '/api/offerwalls',
      get: (offerwallId: string) => `/api/offerwalls/${offerwallId}`,
      offers: (offerwallId: string) => `/api/offerwalls/${offerwallId}/offers`
    }
  }
};